import { RegisterOptions } from 'react-hook-form'

interface PhoneValidationArgs {
  validity?: boolean
  invalidMsg?: string
}

export const usePhoneValidation = ({ validity, invalidMsg }: PhoneValidationArgs): RegisterOptions['validate'] => {
  if (typeof validity === 'undefined') {
    return {}
  }

  return {
    invalid: () => {
      return validity || (invalidMsg ?? '')
    },
  }
}
